export const PHONE_LEAD_LABEL = '(Phone lead)';

/**
 * Whether a lead renders as the shared phone-lead label rather than a name. Surfaces that
 * capitalize the name need this to skip the transform — otherwise the label reads "(Phone Lead)"
 * there and stops matching the messaging surfaces. Derived from the lead, not from comparing the
 * rendered string against user-facing copy, so the styling follows the semantic and survives a
 * copy change.
 */
export function isNamelessPhoneLead(renterName: string | null | undefined, isPhoneLead: boolean | undefined): boolean {
  return Boolean(isPhoneLead && !renterName);
}

/**
 * Display name for a lead. A nameless phone lead reads "(Phone lead)" on every surface; what a
 * nameless non-phone lead reads is the caller's choice via `fallback` — the messaging window
 * keeps the 'Renter' default, list/header surfaces pass their own copy ('' to render nothing).
 * Display-only: pass the raw name to AvatarGroup so "(Phone lead)" never becomes avatar initials.
 */
export default function getRenterDisplayName(
  renterName: string | null | undefined,
  isPhoneLead: boolean | undefined,
  fallback = 'Renter',
): string {
  if (isNamelessPhoneLead(renterName, isPhoneLead)) return PHONE_LEAD_LABEL;
  return renterName || fallback;
}
